import {createContext} from 'react';

/**
 * When Icon is rendered inside IconSet CF-054 (value prop), this is set to 'valueProp'
 * so Icon uses Value Prop styling. CF-053 press logos uses default ('icons') styling.
 * @type {React.Context<'icons'|'valueProp'>}
 */
export const IconSetSectionContext = createContext('icons');
